export const CAMPAGNE_TYPES = [
  { value: " ", label: "Choisissez un type de campagne" },
  { value: "DISTRIBUTION", label: "DISTRIBUTION" },
  { value: "DECLARATION_TEMPS", label: "DECLARATION_TEMPS" },
  { value: "DECLARATION_MAX", label: "DECLARATION_MAX" },
];
